<template>
    <div class="row mx-0 col-12 px-0">
        <h3 class="theme-primary col-12 px-0">{{title}}</h3>
        <div class="row mx-0 mb-3 col-12 px-0">
            <label for="email" class="col-12 px-0 theme-primary font-weight-bold">{{emailLabel}}</label>
            <input type="text" id="email" class="form-control col-12 col-lg-8" v-bind:class="{'error': inEmailAddressError}" v-model="value" @blur="onEmailAddressBlur" />    
        </div>
        <p v-if="inEmailAddressError" class="mb-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{invalidEmail}}</p> 
        <div class="row mx-0 col-12 px-0">
            <label for="confirmEmail" class="col-12 px-0 theme-primary font-weight-bold">{{confirmLabel}}</label>
            <input type="text" id="confirmEmail" class="form-control col-12 col-lg-8" v-bind:class="{'error': inConfirmEmailAddressError}" v-model="confirmValue" @blur="onConfirmEmailAddressBlur"/>
        </div>
        <p v-if="inConfirmEmailAddressError" class="mt-2 errorMsg" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{matchError}}</p>
    </div>
</template>

<script>
    export default {
        name: "EmailAddress",

        emits: ['update-email-address'],

        props: {
            title: String,
            emailLabel: String,
            confirmLabel: String,
            email: String,
            confirmEmail: String,
            matchError: String,
            invalidEmail: String
        },

        data: function() {
            return {
                value: this.email,
                confirmValue: this.confirmEmail,
                inEmailAddressError: null,
                inConfirmEmailAddressError: null
            }
        },

        methods: {
            isEmailAddressValid: function() {
                var valid;
                var atIndex = this.value.indexOf('@');
                var periodIndex = this.value.lastIndexOf('.');
                valid = atIndex >= 1 && atIndex <= (periodIndex - 2);
                return valid && periodIndex < this.value.length - 2;
            },
            isConfirmEmailAddressValid: function() {
                return this.confirmValue === this.value && this.confirmValue !== "";
            },
            onEmailAddressBlur: function() {
                this.setInEmailAddressError();
                if(this.confirmValue != "")
                    this.setInConfirmEmailAddressError();
            },
            onConfirmEmailAddressBlur: function() {
                this.setInConfirmEmailAddressError();
            },
            setInEmailAddressError: function(){
                this.inEmailAddressError = !(this.isEmailAddressValid());
                return !this.inEmailAddressError;
            },
            setInConfirmEmailAddressError: function() {
                this.inConfirmEmailAddressError = !(this.isConfirmEmailAddressValid());
                return !this.inConfirmEmailAddressError;
            },
            validateAndEmitEmailAddress: function () {
                this.emitEmailAddress(this.isEmailAddressValid() && this.isConfirmEmailAddressValid() ? this.value : "");
            },
            emitEmailAddress: function(val){
                this.$emit('update-email-address', val)
            }
        },

        watch: {
            email: function(val) {
                this.value = val
            },

            confirmEmail: function(val) {
                this.confirmValue = val;
            },

            value: function() {
                this.inEmailAddressError = false;
                this.inConfirmEmailAddressError = false;
                this.validateAndEmitEmailAddress(); 
            },
            confirmValue: function(){
                this.inConfirmEmailAddressError = false;
                this.validateAndEmitEmailAddress();
            }
        }
    }
</script>
